/* eslint-disable no-shadow */

export enum FormPaymentMethodType {
  CREDIT_CARD = "creditcard",
  ACH = "ach",
  BACS = "bacs",
  PAD = "pad",
  SEPA = "sepa",
}

interface CreditCardTypesObjType {
  [key: string]: string;
}

export const ZuoraCreditCardTypes: CreditCardTypesObjType = {
  visa: "Visa",
  mastercard: "MasterCard",
  "american-express": "AmericanExpress",
  discover: "Discover",
};

export interface ZuoraQueryParamsType {
  responseFrom: string;
  success: "true" | "false";
  signature: string;
  refId: string; // payment method id
  field_passthrough1: string; // account id
  field_passthrough2: FormPaymentMethodType; // payment method type
  field_passthrough3: "true" | "false"; // set default payment method as default
  field_passthrough4: string; // nickname
  field_passthrough5: ""; // selected invoice ids
  field_passthrough6: ""; // selected payment method id
  field_passthrough7: "true" | "false"; // is 3DS payment method
  errorCode: string; // when success is false
  errorMessage: string;
}

export enum StripeSupportedCurrency {
  Usd = "usd",
  Gbp = "gbp",
  Cad = "cad",
}
